/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createFieldHook } from '../../core/factories/createFieldHook.js';
import { createListHook } from '../../core/factories/createListHook.js';
import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetPositionsRow } from '../openapi-types.gen.js';
import type { PagedData } from '../../types/PagedData.js';
import { type useGetPositionsArgs, useGetPositionsSpec, useGetPositionsRealtime, useGetPositionsPagination } from '../specs/users.spec.gen.js';
import type { PaginationContract } from '../../core/factories/createListHook.js';

export type { GetPositionsRow } from '../openapi-types.gen.js';
export type { useGetPositionsArgs } from '../specs/users.spec.gen.js';

// Codegen-typed pagination contract is narrower than the runtime
// PaginationContract signature (which takes unknown args). The cast erases
// the call-site narrowness — the runtime fetcher itself remains typed.
const _useGetPositionsPaginationContract = useGetPositionsPagination as unknown as PaginationContract;

/**
 * Manual pagination: returns `fetchNextPage` / `hasNextPage` /
 * `isFetchingNextPage` so the caller wires a "Load more" button or
 * pagination control. Same cache entry as `useGetPositionsInfinite` — both
 * read/write the same `PagedData<GetPositionsRow>` blob.
 *
 * @remarks Available query params (forwarded automatically; pass
 * via the hook's args): userId, walletPubkeys, market, marketPubkeys, outcomeMints, positionType, status, includeZero, sortBy, sortOrder, limit, cursor, fields.
 */
export const useGetPositions = createListHook({
  spec: useGetPositionsSpec,
  realtime: useGetPositionsRealtime,
  entityKey: 'user',
  pagination: _useGetPositionsPaginationContract,
});


/**
 * Auto-infinite: same cache as `useGetPositions`, but the last-row viewport
 * sentinel auto-fires `fetchNextPage` so the consumer never has to wire
 * it. Use for scroll-driven feeds; use `useGetPositions` for "Load more"
 * buttons / non-scroll UX.
 */
export const useGetPositionsInfinite = createListHook({
  spec: useGetPositionsSpec,
  realtime: useGetPositionsRealtime,
  entityKey: 'user',
  pagination: _useGetPositionsPaginationContract,
  autoLoadMore: true,
});


/**
 * Per-field subscription hook for the `useGetPositions` cache entry. Call inside
 * an `<Items>` render tree (typically from a leaf component). Returns the
 * named field's value for the given row id; only the call site re-renders
 * when that field changes. Uses TanStack's canonical "per-component select"
 * pattern internally.
 *
 *     function Volume({ pubkey }) {
 *       const value = useGetPositionsField(pubkey, 'volume24h');
 *       return <span>{value}</span>;
 *     }
 */
export const useGetPositionsField = createFieldHook<GetPositionsRow>('useGetPositionsField');

/**
 * Hover/intent prefetch companion for `useGetPositions` (also covers
 * `useGetPositionsInfinite` — same cache entry). Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * for page 1 and writes the response into the cache. The component owning
 * the callback does NOT subscribe — no re-renders on data, no NATS
 * subscription. Idempotent: TanStack `prefetchQuery` is a no-op when a
 * fresh cache entry already exists.
 *
 *     function NavLink() {
 *       const prefetch = usePrefetchGetPositions();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({})}
 *           onFocus={() => prefetch({})}
 *         >Markets</a>
 *       );
 *     }
 */
export const usePrefetchGetPositions = createPrefetchHook(useGetPositionsSpec);
